export const environment = {
  isDev: process.env.REACT_APP_IS_DEV === 'true',
  isProd: process.env.REACT_APP_IS_PROD === 'true',
  assetName: process.env.REACT_APP_ANALYTICS_NAME,
  internalDomains: process.env.REACT_APP_ANALYTICS_INTERNAL_DOMAINS,
  warnAnalytics: process.env.REACT_APP_WARN_ANALYTICS === 'true'
}
